import { useEffect, useState } from "react";
import { FaMapMarkerAlt, FaTags } from "react-icons/fa";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import {
  useFindFavouriteByCustomerIdMutation,
  useUpdateCustomerFavouriteMutation,
} from "../../../redux/services/favouriteApi";
import { getUserData, selectJwtToken } from "../../../redux/slices/authSlice";
import {
  getFavouriteData,
  getFavouriteTotalPages,
  getFavouriteTotalRecord,
  setFavouriteDetail,
} from "../../../redux/slices/favouriteSlice";
import { getLocation } from "../../../redux/slices/navSlice";
import {
  calculateDistance,
  currencyFormatter,
} from "../../../redux/services/utility";
import { IoMdCar } from "react-icons/io";
import { RiParkingBoxLine } from "react-icons/ri";
import { BsFillEmojiFrownFill, BsHeart, BsHeartFill } from "react-icons/bs";
import Loading from "../../commons/Loading";
import { useNavigate } from "react-router-dom";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { AiOutlineCloseCircle } from "react-icons/ai";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import RegularModal from "../../../components/Modals/RegularModal";
import MuiAlert from "../../MuiAlert/MuiAlert";
import "../../Home/Style.css";
import RegularButton from "../../../components/Buttons/RegularButton";

type Props = {};
const Favourite = (props: Props) => {
  const navigate = useNavigate();
  const userLocation: any = useAppSelector(getLocation);
  const [favourite, setFavourite] = useState<any>([]);
  const totalPageRecord = useAppSelector(getFavouriteTotalPages);
  const favouriteData = useAppSelector(getFavouriteData);
  const favouriteRecord: any = useAppSelector(getFavouriteTotalRecord);
  const [totalRecord, setTotalRecord] = useState(0) as any;
  const dispatch = useAppDispatch();
  const [findFavouriteByCustomerId, favouriteResponse] =
    useFindFavouriteByCustomerIdMutation();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const customerId = currentUser?.customerId;
  const userData = useAppSelector(getUserData);
  const [updateCustomerFavourite, updateCustomerFavouriteResponse] =
    useUpdateCustomerFavouriteMutation();
  const [offset, setOffset] = useState(6);
  const [page, setPage] = useState(0);
  const [visibles, setVisibles] = useState(false);
  const [parkingCategory, setParkingCategory] = useState([]);
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);

  const getFavouriteDetailByPagination = async (
    reqOffset: number,
    reqPage: number
  ) => {
    await findFavouriteByCustomerId({
      token: token,
      payload: {
        limit: reqOffset,
        offset: reqOffset,
        pageNumber: reqPage,
        customerId: customerId,
        status: true,
      },
    });
  };

  useEffect(() => {
    if (token) {
      findFavouriteByCustomerId({
        token: token,
        payload: {
          customerId: customerId,
          limit: offset,
          pageNumber: page,
          status: true,
        },
      });
    }
  }, [token]);

  useEffect(() => {
    if (favouriteResponse.isSuccess) {
      let favouriteData: any = favouriteResponse.data;
      dispatch(setFavouriteDetail(favouriteResponse.data));
      setFavourite(favouriteData.data);
      setTotalRecord(favouriteRecord);
    }
  }, [favouriteResponse.isSuccess]);

  useEffect(() => {
    if (favouriteData) {
      setFavourite(favouriteData);
      setTotalRecord(favouriteRecord);
    }
  }, [favouriteData]);

  const toggleFavourites = (parkingId: number, id: number) => {
    let payload = {
      parkingLocationId: parkingId,
      id: id,
      customerId: customerId,
      limit: offset,
      pageNumber: page,
      status: false,
    };
    updateCustomerFavourite({
      token: token,
      payload: payload,
    });
  };
  useEffect(() => {
    if (updateCustomerFavouriteResponse.isSuccess) {
      findFavouriteByCustomerId({
        token: token,
        payload: {
          customerId: customerId,
          limit: offset,
          pageNumber: 0,
          status: true,
        },
      });
      setPage(0);
      setStatusCode({ type: "success", code: "ADDING_PARKING_TO_FAVOURITE" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
    if (updateCustomerFavouriteResponse.isError) {
      setStatusCode({
        type: "error",
        code: "ERROR_ON_ADDING_PARKING_TO_FAVOURITE",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [
    updateCustomerFavouriteResponse.isSuccess,
    updateCustomerFavouriteResponse.isError,
  ]);

  const handleLoadMore = () => {
    setPage(page + 1);
    getFavouriteDetailByPagination(offset, page + 1);
  };

  const handleLoadMores = () => {
    setPage(page - 1);
    getFavouriteDetailByPagination(offset, page - 1);
  };

  const viewMoreClosed = () => {
    setVisibles(false);
  };

  return (
    <div className="rounded-[8px] border-2 m-[10px] md:m-[50px] md:mx-8 mx-2 p-[10px] md:p-[20px]">
      <p className="text-[#434343] font-medium lg:text-[32px] text-[26px] mb-[24px] ml-6">
        Favourites
      </p>
      {isAlertVisible && (
        <div className="w-full lg:flex block  lg:flex-wrap justify-center ">
          <MuiAlert
            severity={statusCode?.type!}
            messageType={statusCode?.code!}
          />
        </div>
      )}
      <div className="overscroll-none justify-center">
        <div className="flex flex-wrap px-3 place-content-center">
          {favourite &&
            favourite.map((response: any, index: any) => {
              let parkingId: any = response.parkingLocationId;
              return (
                <div>
                  <div
                    key={index}
                    className="mt-8 justify-center rounded-[16px]"
                  >
                    <div key={index} className="my-2">
                      <div className="lg:w-[275px] md:w-[368px] w-[92%] justify-between md:ml-4  md:h-[400px] h-[50%] ml-4 border  drop-shadow-xl rounded-[16px] relative overflow-hidden">
                        <div className="flex p-[17px] h-[80%] ">
                          <div className=" items-center flex-1">
                            <div
                              className="rounded-[8px] mr-[10px] md:mr-0 "
                              style={{
                                backgroundImage: `url(${
                                  response.parkingSpaceLocationData
                                    ?.imageList &&
                                  response.parkingSpaceLocationData
                                    ?.imageList[0].filePreSignedUrl
                                })`,
                                backgroundSize: "100%",
                                backgroundRepeat: "no-repeat",
                                height: "130px",
                              }}
                            >
                              <div className="items-end">
                                <button
                                  onClick={() =>
                                    toggleFavourites(parkingId, response.id)
                                  }
                                  className={
                                    "relative  h-[50px] w-[50px] rounded-full flex items-center justify-center hover:bg-gray-300  hearticonforfavourite  left-[150px] md:left-[260px] lg:left-[180px]"
                                  }
                                >
                                  {response.parkingSpaceLocationData
                                    ?.isFavourite == "true" ? (
                                    <BsHeart
                                      color="white"
                                      className="text-[26px]"
                                    />
                                  ) : (
                                    <BsHeartFill
                                      color="#E23744"
                                      className="text-[26px] "
                                    />
                                  )}
                                </button>
                              </div>
                            </div>
                            <Tooltip
                              title={response.parkingSpaceLocationData?.name}
                              placement="bottom-start"
                              className=" "
                            >
                              <h3 className="text-[20px] mt-2 font-bold truncate w-[12rem] text-zinc-600">
                                {response.parkingSpaceLocationData?.name}
                              </h3>
                            </Tooltip>
                            <div className="flex items-center text-base text-gray-500 font-medium">
                              <FaMapMarkerAlt className="text-lg mr-2" />
                              <Tooltip
                                title={
                                  response.parkingSpaceLocationData?.address
                                }
                                placement="bottom-start"
                                className=" "
                              >
                                <p className="text-base text-gray-500 font-medium truncate w-[12rem]">
                                  {response.parkingSpaceLocationData?.address}
                                </p>
                              </Tooltip>
                            </div>

                            <p className="flex items-center text-base text-gray-500">
                              <IoMdCar className="mr-2 mt-1 text-lg" />
                              {calculateDistance(
                                userLocation?.lat,
                                userLocation?.lng,
                                response.parkingSpaceLocationData?.latitude,
                                response.parkingSpaceLocationData?.longitude
                              )}
                              Km
                            </p>

                            <div className="flex items-center text-base text-gray-500 font-medium">
                              <RiParkingBoxLine className="text-lg mr-2" />
                              <p>
                                {response.parkingSpaceLocationData
                                  ?.availableSlots === null
                                  ? `${response.parkingSpaceLocationData?.capacity} Slots`
                                  : `${response.parkingSpaceLocationData?.availableSlots} Available slots`}{" "}
                              </p>
                            </div>
                            {response.parkingSpaceLocationData?.hourlyLimit >
                              0 && (
                              <div className="flex items-center text-base text-slate-500 font-medium">
                                <FaTags className="text-lg mr-2" />
                                <p className="truncate w-[11rem]">
                                  {response.parkingSpaceLocationData
                                    ?.hourlyRate &&
                                    `Hourly Rate: $${response.parkingSpaceLocationData?.hourlyRate} /hr`}
                                </p>
                              </div>
                            )}
                            {response.parkingSpaceLocationData?.dailyLimit >
                              0 && (
                              <div className="flex items-center text-base text-slate-500 font-medium">
                                <FaTags className="text-lg mr-2" />
                                <p className="truncate w-[11rem]">
                                  {response.parkingSpaceLocationData
                                    ?.dailyRate &&
                                    `Daily Rate: $${response.parkingSpaceLocationData?.dailyRate} /day`}
                                </p>
                              </div>
                            )}
                            {(response?.parkingSpaceLocationData
                              ?.rlSourceLocation == null ||
                              response?.parkingSpaceLocationData
                                ?.rlSourceLocation == "SF") && (
                              <div className=" cursor-pointer">
                                {response?.parkingSpaceLocationData &&
                                response?.parkingSpaceLocationData !== null ? (
                                  <span
                                    onClick={() => {
                                      setVisibles(true);
                                      setParkingCategory(
                                        response?.parkingSpaceLocationData
                                          ?.parkingCategoryResDTOS
                                      );
                                    }}
                                    className="text-red-500"
                                  >
                                    {"View Tariff >>"}
                                  </span>
                                ) : null}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="flex justify-center h-[20%] p-2 mt-2">
                          <RegularButton
                            className="text-white w-[80%] mb-2 p-1 bg-red-600 font-bold rounded-lg"
                            onClick={() =>
                              navigate("/profile/Booking-detail", {
                                state: {
                                  selectedParking:
                                    response.parkingSpaceLocationData,
                                  checkOut: "",
                                  checkIn: "",
                                },
                              })
                            }
                            disabled={
                              response.parkingSpaceLocationData.status === false
                                ? true
                                : false
                            }
                            title={
                              response.parkingSpaceLocationData.status === false
                                ? "Parking not available"
                                : "Book Now"
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      {favourite && favourite.length === 0 ? (
        <div className="justify-between items-center flex flex-col mt-6 mb-10">
          <BsFillEmojiFrownFill size={70} color={"ef4444"} />
          <h5 className="text-xl pt-4">No favourite in your list!!!</h5>
        </div>
      ) : (
        <div className="flex gap-6 justify-center">
          <button
            onClick={() => {
              handleLoadMores();
            }}
            disabled={page == 0 ? true : false}
            className={` p-2 rounded-[8px] flex items-center ${
              page == 0
                ? "bg-slate-300 text-black"
                : "text-white bg-[#E23744] hover:bg-red-700 "
            }`}
          >
            <BiChevronLeft />
            Previous{" "}
          </button>
          <button
            onClick={() => {
              handleLoadMore();
            }}
            disabled={page + 1 == totalPageRecord ? true : false}
            className={` p-2 flex items-center rounded-[8px] ${
              page + 1 == totalPageRecord
                ? "bg-slate-300 text-black"
                : "text-white bg-[#E23744] hover:bg-red-700 "
            }`}
          >
            Next
            <BiChevronRight />
          </button>
        </div>
      )}
      {favouriteResponse.isLoading ||
      updateCustomerFavouriteResponse.isLoading ? (
        <Loading />
      ) : null}

      {visibles && (
        <RegularModal
          modalDialogStyle="w-[350px] h-[450px] md:w-[800px] "
          visible={visibles}
          setVisible={setVisibles}
        >
          <div className="justify-center">
            <div className="flex">
              <h2 className="text-[16px] mt-4 font-bold ml-6">
                Category And Pricing Details
              </h2>
              <button onClick={() => viewMoreClosed()}>
                <AiOutlineCloseCircle className="ml-[90px]  md:ml-[450px] text-red-500 text-end text-[33px] " />
              </button>
            </div>
            <div className="mt-5">
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow
                      style={{
                        fontSize: "50px",
                        fontWeight: "bold",
                        color: "black",
                      }}
                    >
                      <TableCell align="left">Vehicle Category</TableCell>
                      <TableCell align="left">Vehicle Sub Category</TableCell>
                      <TableCell align="left">Cancellation Due Time</TableCell>
                      <TableCell align="left">Minimum Booking (Hr)</TableCell>
                      <TableCell align="left">Private Price{""}(₹)</TableCell>
                      <TableCell align="left">
                        Commercial Price{""}(₹)
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {parkingCategory &&
                      parkingCategory.map((row: any, index: any) => (
                        <TableRow
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                          key={index}
                        >
                          <TableCell align="left">
                            {row.categoryName == 0 || row.categoryName == null
                              ? "NA"
                              : row.categoryName}
                          </TableCell>
                          <TableCell align="left">
                            {row.subCategoryName == 0 ||
                            row.subCategoryName == null
                              ? "NA"
                              : row.subCategoryName}
                            -
                            {row.bookingType == 0 || row.bookingType == null
                              ? "NA"
                              : row.bookingType}
                          </TableCell>
                          <TableCell align="left">
                            {row.cancellationDueTime}
                            {""}hrs
                          </TableCell>
                          {row.subCategoryName == "Monthly" ||
                          row.subCategoryName === "Weekly" ? (
                            <TableCell align="left">NA</TableCell>
                          ) : (
                            <TableCell align="left">
                              {row.minimumBookingHours}
                              {""}hrs
                            </TableCell>
                          )}
                          <TableCell align="left">
                            {currencyFormatter.format(row.dailyRate)}
                          </TableCell>
                          <TableCell align="left">
                            {currencyFormatter.format(row.commRate)}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
                {favouriteResponse && favouriteResponse ? (
                  ""
                ) : (
                  <Typography gutterBottom align="center" variant="subtitle1">
                    No record found!!!{" "}
                  </Typography>
                )}
              </TableContainer>
            </div>
          </div>
        </RegularModal>
      )}
    </div>
  );
};
export default Favourite;
